
import { Component, Input, OnChanges, SimpleChanges} from "@angular/core";
import { Article } from './../ceo-desk.model';
import { Router } from "@angular/router";

@Component({
    selector: "app-article-card",
    templateUrl: "./article-card.component.html",
    styleUrls:["./article-details-mobile.component.scss"]
})

export class ArticleCardComponent implements OnChanges {
   constructor(private router:Router){}
    @Input() article = new  Article();

    @Input() hideDecription:boolean = false;

    isYoutubeVedio : boolean = false

    ngOnChanges(changes: SimpleChanges){
       if(changes.article.currentValue.video){
        this.isYoutubeVedio = changes.article.currentValue.video.startsWith('https://youtu.be/');
       }
    }

    viewDetails() {
        console.log(this.article)
        if (this.article.type == "Market Insights" && this.article.pdfUrl) {
            window.open(this.article.pdfUrl, '_blank');
        }
        else {
            // this.router.navigate(['/articles'], { queryParams: { 'article-id': this.article.id, 'category': this.article.type } });
            this.router.navigate(['/cio-desk/articles'], {
                queryParams: {
                    'article-id': this.article.id,
                    'catergory': this.article.type
                }
            });
        }
    }
}
  